import { Component, Input, OnInit } from '@angular/core';
import { DateHelper } from '@osapp/helpers';
import { ETimetablePattern } from '@osapp/model';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { PatientsService } from 'apps/idl/src/modules/patients/services/patients.service';
import { PatientHelper } from '../../helpers/patient.helper';
import { SSNHelper } from '../../helpers/ssn.helper';

@Component({
  selector: 'di-donnees-patient-cv',
  templateUrl: './donnees-patient-cv.component.html',
  styleUrls: ['./donnees-patient-cv.component.scss'],
})
export class DonneesPatientCVComponent implements OnInit {

  @Input() public patient?: IPatient;
  public formattedBirthDate: string = '';
  public formattedSSN: string = '';
  public formattedLastName: string = '';
	public formattedFirstName: string = '';

  constructor(private svcPatients: PatientsService) {}

  ngOnInit(): void {
    if (this.patient) {
      this.formattedBirthDate = DateHelper.transform(this.patient.birthDate, ETimetablePattern.dd_MM_yyyy_slash);
      this.formattedSSN = SSNHelper.formatSSN(this.patient.socialNumber);
      this.formattedLastName = PatientHelper.getFullNamePatient(this.patient);
			this.formattedFirstName = PatientHelper.getPatientFirstName(this.patient);

    }
  }
}
